import React, { useEffect, useState } from 'react';
import {
  Card,
  CardContent,
  Grid,
  Paper,
  Typography,
  Divider,
  TextField,
  Box,
  Button,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import CandidateService from '../../services/candidateService';
import { selectRegNumber, setSelectedURLs } from '../../actions/fileActions';
import HeightBox from '../../components/HeightBox';
import SearchFilters from './filters';
import { useSelector,useDispatch } from 'react-redux';
import UserProfileContainer from './view/profile';
import { filterCandidateAction } from './actions';
import { getAllJobOrders,createJobOrderCandidate } from '../jobOrders/services'
import { IconButton, List, ListItem, ListItemText} from '@mui/material';
import { CheckCircleOutline as CheckCircleOutlineIcon, Filter3Sharp } from '@mui/icons-material';
import InsightsDashboard from '../candidateAnalytics';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {CircularProgress} from '@mui/material';
import PropTypes from 'prop-types';

import Skeleton from '@mui/material/Skeleton';

const variants = ['h1', 'h3', 'body1', 'caption'];

function TypographyDemo(props) {
  const { loading = false } = props;

  return (
    <div>
      {variants.map((variant) => (
        <Typography component="div" key={variant} variant={variant}>
          {loading ? <Skeleton /> : variant}
        </Typography>
      ))}
    </div>
  );
}

TypographyDemo.propTypes = {
  loading: PropTypes.bool,
};

const JobOrderDialog = ({ open, onClose, jobOrders, selectedJobOrderId,selectedEmployeeId }) => {

  const handleAddToSelectionPool = (jobOrderId) => {
    console.log(jobOrderId)
    createJobOrderCandidate({"jobOrderId":jobOrderId,"candidate":selectedEmployeeId}).then((response)=>{
      console.log(response)
      alert("Candidate added to selection pool")
    }).catch((err)=>{
      console.log(err)
    })
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Job Orders</DialogTitle>
      <DialogContent>
        {jobOrders.length > 0 ? (
          <List>
            {jobOrders.map((jobOrder) => (
              <Box
                key={jobOrder.id}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  background: '#fff',
                  padding: '12px',
                  borderRadius: '4px',
                  marginBottom: '8px',
                }}
              >
                <ListItemText primary={"ID :  " + jobOrder.id + '       Profession : ' + jobOrder.profession + '   QTY: ' + jobOrder.quantity} />
                {selectedJobOrderId === jobOrder.id && <CheckCircleOutlineIcon color="primary" />}
                <IconButton
                  edge="end"
                  aria-label="Add to selection pool"
                  onClick={() => handleAddToSelectionPool(jobOrder.id)}
                >
                  <CheckCircleOutlineIcon color="disabled" />
                </IconButton>
              </Box>
            ))}
          </List>
        ) : (
          <Typography>No job orders available.</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const HeadHuntingBoard = () => {
  
  const filtered = useSelector(state=> state?.filtered)


  const [employees, setEmployees] = useState([
    {
      id: 1,
      name: 'John Doe',
      salaryExpectation: '100,000',
      appliedRole: 'Software Engineer',
      skills: ['JavaScript', 'React', 'Node.js'],
    }
    // Add more employee data as needed
  ]);
  const [jobOrders, setJobOrders] = useState([]);
  const [jobOrderDialogOpen, setJobOrderDialogOpen] = useState(false);
  const [selectedJobOrderId, setSelectedJobOrderId] = useState(null);
  const [selectedEmployeeId, setSelectedEmployeeId] = useState(null); 

  const handleOpenJobOrderDialog = () => {
    setJobOrderDialogOpen(true);
  };

  const handleCloseJobOrderDialog = () => {
    setJobOrderDialogOpen(false);
  };

  const handleAddToSelectionPool = (employeeId) => {
    // Logic to handle adding the employee to the selection pool
    setSelectedEmployeeId(employeeId);
    setJobOrderDialogOpen(true); // Close the dialog after selecting a job order
  };

  const dispatch = useDispatch();
  
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    console.log("filtered",filtered)
    const fetchCandidates = async () => {
      try {
      dispatch(filterCandidateAction(filters));
      setEmployees(filtered.candidates);
      setFilteredEmployees(filtered.candidates);
      setLoading(false);
      } catch (error) {
        console.error('Request failed:', error.message);
        setLoading(false);
      } 
    };
    
    const fetchJobOrders = async () => {
      try {
        const response = await getAllJobOrders();
        console.log(response)
        setJobOrders(response.data);
      } catch (error) {
        console.error('Request failed:', error.message);
      }
    };
    fetchJobOrders();
    fetchCandidates();
  }, []);

  useEffect(() => {
  setEmployees(filtered.candidates);
  setLoading(false)
  console.log("Hi")
  }, [filtered.candidates]);

  function getProfileQty(profiles, timePeriod) {
    const today = new Date();
    const createdAtDates = profiles.map(profile => new Date(profile.createdAt));
  
    switch (timePeriod) {
      case 'today':
        return createdAtDates.filter(date => isSameDate(date, today)).length;
      case 'lastSevenDays':
        const sevenDaysAgo = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000);
        return createdAtDates.filter(date => date >= sevenDaysAgo && date <= today).length;
      case 'lastMonth':
        const thirtyDaysAgo = new Date();
        thirtyDaysAgo.setDate(today.getDate() - 30);
        const profilesCreatedLast30Days = createdAtDates.filter(date => date >= thirtyDaysAgo && date <= today);
        return profilesCreatedLast30Days.length;

        
      default:
        return 0; // Invalid timePeriod
    }
  }
  
  function isSameDate(date1, date2) {
    return (
      date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate()
    );
  }


  const [selectedEmployeeNumber, setSelectedEmployeeNumber] = useState(null);

  const [filters, setFilters] = useState({
    name:'',
    jobTitle: '',
    location: '',
    experience: '',
    skills: '',
    gender:'',
    experienceCountry:'',
    gccExperienced:'',
    availability:'',
    salaryRange: [0, 100000], // Default salary range
    ageRange: [0, 100], // Default age range
  });

  

  const [filteredEmployees, setFilteredEmployees] = useState(employees);

  useEffect(() => {
    console.log(filters);
    const filtered = employees.filter((employee) => {

      const matchesName = filters.name?.length >2
        ? employee?.fullName?.toLowerCase().includes(filters.name.toLowerCase())
        : true;

      const matchesAppliedRole = filters.jobTitle?.length >2
        ? employee?.personalInfo?.appliedPosition?.toLowerCase().includes(filters.jobTitle.toLowerCase())
        : true;
  
      const interestedToWork = filters.location?.length>2
        ? employee?.personalInfo?.interestedToWork?.toLowerCase().includes(filters.location.toLowerCase())
        : true;
  
      const gender = filters.gender?.length>2
        ? employee?.gender?.toLowerCase().includes(filters.gender.toLowerCase())
        : true;
  
      const availability = filters.availability?.length>2
        ? employee?.availability?.toLowerCase() === filters.availability.toLowerCase()
        : true;
      
      const minimumExperience = filters.experience?.length>0
        ? parseInt(employee?.personalInfo?.totalYearsOfExperience) >= filters.experience
        : true;

      const experienceCountry = filters.experienceCountry?.length > 2
        ? employee?.workExperience?.some((exp) => exp?.location?.toLowerCase().includes(filters.experienceCountry.toLowerCase()))
        : true;
      
      const gccExperienced = filters.gccExperienced === 'yes'
        ? employee?.workExperience?.some((exp) => exp?.location?.toLowerCase().includes('dubai'||'abu dhabi'||'sharjah'||'ajman'||'ras al khaimah'||'fujairah'||'umm al quwain' || 'saudi arabia'||'kuwait'||'bahrain'||'qatar'||'oman'))
        : true;
      
      return matchesAppliedRole && interestedToWork && gender && availability && matchesName && minimumExperience && experienceCountry && gccExperienced;
    });
  
    console.log(filtered);
    setFilteredEmployees(filtered);
  }, [filters]);
  
  

  
  const handleMoreDetails = (employeeId) => {
    // Handle the action when the "More Details" button is clicked
    console.log('More Details clicked for employeeId:', employeeId);
  };
  const [step, setStep] = useState(1);
  const [formValues, setFormValues] = useState({});
  const [files, setFiles] = useState([]);

  
  const fetchFiles = async () => {
    try {
      const user = localStorage.getItem('user');
      const token = JSON.parse(user).data.token;
      const response = await fetch(`https://oseas-api.hypen.lk/api/v1/candidates/files/1`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
        }
      });

      if (response.ok) {
        // Request successful
        const data = await response.json();
        console.log(data);
        setFiles(data);

      } else {
        // Request failed
        console.error('Request failed:', response.status);
      }
    } catch (error) {
      console.error('Request failed:', error.message);
    }
  };

  
  const handleViewProfile = async (employeeId) => {
    // Handle the action when the "Add to Selection Pool" button is clicked
    console.log('searching');
    dispatch(setSelectedURLs([]));
    try {

      const response = await CandidateService.searchCandidate(employeeId);
      setFormValues(response.data);
      console.log(response.data)
      setStep(2);
     
    } catch (error) {
      console.error('Request failed:', error.message);
    }
    fetchFiles();
    dispatch(selectRegNumber(employeeId));
    
    console.log('Add to Selection Pool clicked for employeeId:', employeeId);
    handleOpenDialog(employeeId);
  };




  //dialogbox

  const [dialogOpen, setDialogOpen] = useState(false);

  const handleOpenDialog = (employeeNumber) => {
  
    setSelectedEmployeeNumber(employeeNumber);
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setSelectedEmployeeNumber(null);
    setDialogOpen(false);
  };
 
  
  const handleFilterChange = (event) => {
    const { name,value } = event.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));
  };

  const ProfileQuantityCard = ({ title, quantity }) => {
    return (
      <Card style={{borderRadius:'20px'}}>
        <CardContent>
          <Typography variant="h8" component="h3" gutterBottom>
            {title}
          </Typography>
          <Typography variant="h4" component="p" align="center">
            {quantity}
          </Typography>
        </CardContent>
      </Card>
    );
  };

  const todayProfileQty = getProfileQty(employees, 'today');
  const lastSevenDaysProfileQty = getProfileQty(employees, 'lastSevenDays');
  const lastMonthProfileQty = getProfileQty(employees, 'lastMonth');

  useEffect (() => {
    console.log('employees', employees);
    setFilters({
      name:'',
      jobTitle: '',
      location: '',
      experience: '',
      skills: '',
    
    })
  }, [filtered]);
  
  return (
    <Card style={{background:'white'}}>
    <CardContent>

    <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography>Candidates insights</Typography>
        </AccordionSummary>
        <AccordionDetails>
        {employees.length > 0 && (
        <InsightsDashboard candidates={employees} />
          )
        }
        </AccordionDetails>
      </Accordion>
        
    {
      loading && (
        <div style={{display:'flex',justifyContent:'center',alignItems:'center',height:'80vh'}}>
          <CircularProgress />
        </div>
      )
    }
    <Grid container spacing={2} style={{marginTop:4}}>
        <Grid item xs={3}>
        <SearchFilters     
        handleFilterChange={handleFilterChange}
        filters={filters}
        />
        </Grid>

      

        <Grid item xs={9} >
          <Grid container spacing={2} style={{marginTop:10}}>
          <Grid container spacing={2} style={{paddingLeft:20,paddingRight:20,paddingBottom:10,fontSize:12}}>
            <Grid item xs={4}>
              <ProfileQuantityCard title="Created Today" quantity={todayProfileQty} />
            </Grid>
            <Grid item xs={4}>
              <ProfileQuantityCard title="Created in the Last 7 Days" quantity={lastSevenDaysProfileQty} />
            </Grid>
            <Grid item xs={4}>
              <ProfileQuantityCard title="Created in the last 30 Days" quantity={lastMonthProfileQty} />
            </Grid>
          </Grid>
          <Chip label={"Found " + filteredEmployees.length + " Candidates"} style={{ marginLeft:'20px',marginRight: '0.5rem', marginBottom: '0.5rem' }} />

          <Grid item xs={12} style={{height:'80vh', overflowY: 'scroll' }}>
            {filteredEmployees.length === 0 && 
            <>
              Loading....
             <TypographyDemo loading />
            </>
            }

            {filteredEmployees?.map((employee) => (
              <Grid item xs={12} key={employee.id} style={{paddingTop:0,paddingBottom:10}}>
                <Paper
                    style={{
                      padding: '1rem',
                      marginRight: '1rem',
                      background: '#f7fbff',
                      boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
                      borderRadius: '20px',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'flex-start',
                      justifyContent: 'space-between',
                    }}
                  >
                    <Grid container spacing={2}>
                      <Grid item xs={9}>
                        <div>
                          <Typography variant="h4" style={{ marginBottom: '0.5rem',fontSize:16 }}>
                            {employee.fullName} | Registration No: {employee.regNumber}
                          </Typography>                          
                          <HeightBox height={5}/>

                          <Typography variant="body2" style={{ marginBottom: '0.5rem',fontSize:12 }}>
                            <strong>Salary Expectation: </strong> 
                            
                            {employee?.personalInfo?.expectedSalaryPackage && (
                          <span>
                            {employee?.personalInfo?.expectedSalaryPackageCurrency}{' '}
                            {Number(employee?.personalInfo.expectedSalaryPackage).toLocaleString('en-US', {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </span>
                          )}

                            | <strong> Applied Role:</strong> {employee?.personalInfo?.appliedPosition}
                            | <strong> Availability : {employee?.availability}</strong> {employee.location}
                          </Typography>


                          <Typography variant='body2' style={{fontSize:12}} >
                            Years Of Experience : {employee?.personalInfo?.totalYearsOfExperience}
                            </Typography>
                            <Typography variant='body2' style={{fontSize:12}} >
                            {employee?.personalInfo?.professionalSummary}
                            </Typography>
                          <HeightBox height={2}/>
                          <div>
                            {employee?.skills?.map((skill, index) => (
                              <Chip
                                key={index}
                                label={skill}
                                style={{ marginRight: '0.5rem', marginBottom: '0.5rem' }}
                              />
                            ))}
                          </div>
                          <HeightBox height={2}/>
                          {filters.gccExperienced === 'yes' && <>
                          <strong>Work Experience</strong>

                              {
                                employee.workExperience.map((exp) => (
                                  <div>
                                    <Typography variant='body2' style={{fontSize:12}} >
                                    {exp?.location} | {exp?.company} | {exp?.designation} | {exp?.start} - {exp?.complete}
                                    </Typography>
                                  </div>
                                ))
                        
                              }
                          </>
                          }
                            
                        </div>
                      </Grid> 
                      <Grid item xs={3}>
                      
                      
                      <Grid item xs={12}>
                        <Button
                          variant="contained"
                          size="small"
                          color="primary"
                          fullWidth
                          onClick={() => handleViewProfile(employee.regNumber)}
                          style={{backgroundColor:'#37b6ff', marginBottom: '0.5rem' }}
                        >
                          Profile
                        </Button>
                      </Grid>
                      <Grid item xs={12}>
                        <Button
                          variant="contained"
                          size="small"
                          fullWidth
                          style={{ backgroundColor: '#2ecc71', color: '#ffffff' }}
                          onClick={() => handleAddToSelectionPool(employee.id)}
                        >
                          Recommend
                        </Button>
                      </Grid>

                      </Grid> 
                    </Grid>
                    
                   
                </Paper>
              </Grid>
              
            ))}

          </Grid>
          </Grid>
        </Grid>
      </Grid>
    </CardContent>

    {/* Dialog Box */}
    <Dialog sx={{left:'10%'}} maxWidth='md' open={dialogOpen} onClose={handleCloseDialog}>
        <DialogTitle>Candidate Profile</DialogTitle>
        <DialogContent>
          {/* Content inside the dialog */}
          {/* <Typography variant="body1">
            Are you sure you want to recommend Employee {selectedEmployeeNumber}?
          </Typography> */}
          <UserProfileContainer data={formValues}/>
        </DialogContent>
        <DialogActions>
          {/* Actions buttons inside the dialog */}
          <Button onClick={handleCloseDialog} color="primary">
            Close
          </Button>
          {/* <Button onClick={handleCloseDialog} color="primary" variant="contained">
            Recommend
          </Button> */}
        </DialogActions>
      </Dialog>
    
      <JobOrderDialog
        open={jobOrderDialogOpen}
        onClose={handleCloseJobOrderDialog}
        jobOrders={jobOrders}
        selectedJobOrderId={selectedJobOrderId}
        selectedEmployeeId={selectedEmployeeId}
      />

    </Card>

  );
};

export default HeadHuntingBoard;
